function migrate(data) {
  return data
}

export default migrate
